/**
 * Recommendation API Client — 推荐接口
 */

import { apiClient } from './client';

export interface Destination {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  popularity: number;
}

export interface Poi {
  id: number;
  name: string;
  address: string;
  category: string;
  rating: number;
  priceLevel: number;
  city: string;
  description: string;
  images: string;
}

export interface UserTravelProfile {
  userId: number;
  searchedCities: string[];
  categoryViews: Record<string, number>;
  preferredPriceLevel: number;
  preferredTags: string[];
  totalViews: number;
  totalSearches: number;
}

/**
 * 推荐目的地
 */
export async function getRecommendDestinations(userId?: number, city?: string, limit = 10): Promise<Destination[]> {
  const response = await apiClient.get<Destination[]>('/recommendations/destinations', {
    userId, city, limit
  });
  return response.data ?? [];
}

/**
 * 推荐 POI
 */
export async function getRecommendPois(userId?: number, city?: string, limit = 10): Promise<Poi[]> {
  const response = await apiClient.get<Poi[]>('/recommendations/pois', {
    userId, city, limit
  });
  return response.data ?? [];
}

/**
 * 获取用户旅行画像
 */
export async function getUserTravelProfile(userId: number): Promise<UserTravelProfile | null> {
  const response = await apiClient.get<UserTravelProfile>('/recommendations/profile', { userId });
  return response.data ?? null;
}
